import 'react-toastify/dist/ReactToastify.css';
import "aos/dist/aos.css";

import { Backdrop, CircularProgress, ThemeProvider, } from '@mui/material';
import { BrowserRouter as Router, useRoutes } from 'react-router-dom';
import { Suspense, useEffect } from 'react';

import Aos from 'aos';
import CacheProviderRtl from './assets/CacheProvider/CacheProvider';
import CssBaseline from '@mui/material/CssBaseline';
import { ToastContainer } from 'react-toastify';
import routes from './routes';
import theme from './theme';

function App() {
  
	const routing = useRoutes(routes());

	return routing;
}

const AppWrapper = () => {
  useEffect(()=>{
	Aos.init({
		once: true,
		duration:1000,
		delay: 400
	  });
  },[])

	return (
		<CacheProviderRtl>
			<ThemeProvider theme={theme}>
				<Suspense fallback={ <Backdrop
				sx={{ color:'#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
				open
				>
					<CircularProgress color="inherit" />
				</Backdrop>}>
				<Router>
					<CssBaseline />
					<App />
					<ToastContainer      
						rtl 
						position='top-center' 
						autoClose={5000}
						hideProgressBar={true}
						closeOnClick={true}
						pauseOnHover={true}
						draggable={true}
						 
					/>
				</Router>
				</Suspense>
			</ThemeProvider>
		</CacheProviderRtl>
		
	);
};

export default AppWrapper;
